import { render, staticRenderFns } from "./bankAccount.vue?vue&type=template&id=c4b595e2&"
import script from "./bankAccount.vue?vue&type=script&lang=ts&"
export * from "./bankAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports